import { render, staticRenderFns } from "./ComplaintList.vue?vue&type=template&id=4217a97a&scoped=true"
import script from "./ComplaintList.vue?vue&type=script&lang=ts"
export * from "./ComplaintList.vue?vue&type=script&lang=ts"
import style0 from "./ComplaintList.vue?vue&type=style&index=0&id=4217a97a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4217a97a",
  null
  
)

export default component.exports